<template>
  <v-card outlined rounded="lg" elevation="1">
    <v-list-item two-line>
      <v-list-item-avatar>
        <v-icon x-large color="primary"> mdi-account-circle </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium">
          {{ user.name }}
        </v-list-item-title>
        <v-list-item-subtitle
          :class="{ 'text-uppercase': user.user_type == 'tma' }"
        >
          {{
            user.user_type == "doctor" ? user.specialization : user.user_type
          }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <span class="status text-capitalize">
      <v-icon x-small :color="statusColor">mdi-circle</v-icon>
      <span :class="statusTextColor">
        {{ user.status }}
      </span>
    </span>
  </v-card>
</template>

<script>
export default {
  name: "SidebarUser",

  props: {
    user: {
      type: Object,
    },
  },

  computed: {
    statusColor() {
      let status = "";
      switch (this.user.status) {
        case "in call":
          status = "yellow darken-2";
          break;
        case "after call work":
          status = "blue";
          break;
        case "available":
          status = "green";
          break;
        case "online":
          status = "green";
          break;
        case "do not disturb":
          status = "red";
          break;
        case "on break":
          status = "red";
          break;
        case "end of shift":
          status = "red";
          break;
        case "offline":
          status = "grey";
          break;
        case "away":
          status = "grey";
          break;
        default:
          break;
      }

      return status;
    },

    statusTextColor() {
      let status = "";
      switch (this.user.status) {
        case "in call":
          status = "yellow--text text--darken-2";
          break;
        case "after call work":
          status = "blue--text";
          break;
        case "available":
          status = "green--text";
          break;
        case "online":
          status = "green--text";
          break;
        case "do not disturb":
          status = "red--text";
          break;
        case "on break":
          status = "red--text";
          break;
        case "end of shift":
          status = "red--text";
          break;
        case "offline":
          status = "grey--text";
          break;
        case "away":
          status = "grey--text";
          break;
        default:
          break;
      }

      return status;
    },
  },
};
</script>

<style lang="scss" scoped>
.option-link {
  text-decoration: none;
}

.status {
  position: absolute;
  bottom: 7px;
  right: 15px;
  font-size: 13px;
}
</style>
